import { createContext } from 'react'
import type { UseNotificationsResult } from 'shared-components/hooks/use-notifications'

/**
 * The member's own notifications on a member hub page (`useNotifications`, made in `MemberHub`):
 * the tab bar's unread count and the Notifications tab's feed read the same instance, so "Mark
 * all read" clears both. Null for a visitor, a non-owner and while "View as visitor" is on.
 */
export const HubNotificationsContext = createContext<UseNotificationsResult | null>(null)
